import React from 'react';
// import { Button } from '@material-ui/core';
import Button from '@mui/material/Button';
import { useFormikContext } from 'formik';

const SubmitButtonWrapper = ({
  children,
  ...otherProps
}) => {
  const { submitForm } = useFormikContext();

  const handleSubmit = () => {
    submitForm();
  }

  const configButton = {
    variant: 'contained',
    color: 'primary',
    fullWidth: true,
    onClick: handleSubmit
  }

  return (
    <Button
      {...configButton}
    // fullWidth
    >
      {children}
    </Button>
  );
};

export default SubmitButtonWrapper;